import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";
import {
  IoMdLeaf,
  IoMdSunny,
  IoMdNutrition,
  IoMdFemale,
  IoMdPeople,
  IoMdGitNetwork,
  IoMdCheckmarkCircle
} from "react-icons/io";


import Footer from "../ones/Footer";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';


import cln1 from '../assets/banner1.jpg';
import cln2 from '../assets/banner7.jpg';
import cln3 from '../assets/banner3.jpg';
import cln4 from '../assets/banner4.jpg';

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "../ones/HorizontalImagesStrip";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">

										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
											}}
										>
											Environmental Protection and Climate Action
										</h1>
	
									</div>
								</div>
							</div>
						</div>
	
					</div>
				</div>
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12">

								<HorizontalImageStrip
									images={[cln1, cln2, cln3, cln4]}
								/>

								<h6
									style={{
										fontSize: "18px",
										marginTop: "45px",
										marginBottom: "35px",
										textTransform: "uppercase",
										textAlign: "center"
									
									}}
								>
									At FPADI, we believe that &nbsp;
									<span className="text-secondary"><b>environmental protection</b></span> &nbsp; and &nbsp;
									<span className="text-secondary"><b>climate change mitigation</b></span> &nbsp;
									are critical to achieving sustainable development.
									<hr />
								</h6>

								<h5>
									Our Environmental Protection and Climate Change Advocacy service focuses on advocating for policies and practices that promote environmental protection and mitigate the impacts of climate change. We work with stakeholders to create awareness of environmental issues, lobby for policy changes, and promote sustainable development practices that protect our planet and its inhabitants. Our goal is to ensure that our planet remains habitable for future generations.
									<br/><br/>
									Environmental protection and climate change mitigation are crucial to achieving sustainable development. At FPADI, we are committed to working towards a sustainable future by advocating for policies and practices that promote environmental protection and mitigate the impacts of climate change. Our approach is to engage with stakeholders and create awareness of environmental issues, lobby for policy changes, and promote sustainable development practices that protect our planet and its inhabitants. We believe that by working together, we can create a sustainable future for all.
									<br/>
									Our advocacy efforts focus on issues such as deforestation, pollution, and climate change. We work to raise awareness about the impact of these issues on the environment and on our communities. We lobby for policy changes at the local, national, and international levels to ensure that environmental protection and climate change mitigation are at the forefront of policymaking.
									<br/><br/>
									We also work with businesses and organizations to promote sustainable development practices that reduce their environmental impact. We believe that by promoting sustainable practices, we can create a more resilient and sustainable future for all.
								</h5>

								
							</div>

						</div>

						<div className="row text-center justify-content-center mt-3 g-2"> 

								

								<div className="col-md-12 mt-5">
									<h3 className="main-section-title">Advocating for Climate Action in Tanzania</h3>
									<h6>Discover how we advocated for climate action in Tanzania, working with policymakers and community leaders to implement sustainable environmental policies and practices.</h6>
									<div className="row mt-5">
										<div className="col-md-6 px-3 py-2">
											<IoMdSunny size={50} className="text-light mb-2" />
											<h6>Advocacy for climate action</h6>
										</div>

										<div className="col-md-6 px-3 py-2" style={{borderLeft:"1px solid gray"}}>
											<IoMdLeaf size={50} className="text-light mb-2" />
											<h6>Sustainable environmental policies</h6>
										</div>
									</div>
									<h6 className="mt-5 text-start">
										As an environmental NGO, FPADI recognized the importance of advocating for climate action in Tanzania. We recognized that climate change poses significant risks to the environment, livelihoods, and food security, particularly for vulnerable communities. To address this issue, FPADI launched an advocacy campaign aimed at promoting sustainable environmental policies and practices.
										<br/><br/>
										Our advocacy efforts take a multi-pronged approach, incorporating community engagement, policy analysis, and engagement with policymakers and community leaders. We recognize the importance of building a coalition of stakeholders committed to sustainable environmental practices. Our combined efforts led to the implementation of a range of policies and practices aimed at mitigating climate change risks, including sustainable waste management practices, renewable energy initiatives, and afforestation programs. Our advocacy efforts also led to greater engagement by policymakers and community leaders in climate action initiatives.
										<br/><br/>
										Our activities serve as a testament to the power of advocacy in promoting sustainable environmental practices and mitigating climate change risks. FPADI’s commitment to advocacy underscores our belief that sustainable development must be rooted in evidence-based policy and community engagement.
									</h6>
								</div>

							</div>
					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}